/**
 * @class Modal
 */
export default class Modal {
    /**
     * @param {Number} id
     * @param {String} type
     * @param {Number} tabId
     * @param {Object} params
     * @param {String} style
     */
    constructor(id, type, tabId, params, style) {
        this._id = id;
        this._type = type;
        this._tabId = tabId;
        this._params = params === undefined ? null : params;
        this._style = style;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - Modal");
        }

        if (this._type === null) {
            throw new Error("Invalid value of type - Modal");
        }

        if (typeof this._type !== "string") {
            throw new Error("Invalid datatype of type - Modal");
        }

        if (typeof this._tabId !== "number") {
            throw new Error("Invalid datatype of tabId - Modal");
        }

        if (typeof this._style !== "string") {
            throw new Error("Invalid datatype of style - Modal");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get type() {
        return this._type;
    }

    /**
     * @param {String} type
     */
    set type(type) {
        this._type = type;
    }

    /**
     * @return {Number}
     */
    get tabId() {
        return this._tabId;
    }

    /**
     * @param {Number} tabId
     */
    set tabId(tabId) {
        this._tabId = tabId;
    }

    /**
     * @return {Object}
     */
    get params() {
        return this._params;
    }

    /**
     * @param {Object} params
     */
    set params(params) {
        this._params = params;
    }

    /**
     * @return {String}
     */
    get style() {
        return this._style;
    }

    /**
     * @param {String} style
     */
    set style(style) {
        this._style = style;
    }

    /**
     * @return {String}
     */
    toString() {
        return "Modal (" + this._id + ")";
    }

    /**
     * Clones Modal object and updates params property.
     *
     * @param   {Object} params
     * @return  {Object}
     */
    updateParams = (params) => {
        return new Modal(this._id, this._type, this._tabId, params, this._style);
    };
}
